import React, { useState, useEffect, FocusEvent } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { CheckboxStates, WatchedEntryEntity, getEntityIcon, DriveUIActionTypes, DriveEntryType, buildWatchedNavigationLink, PathInfo } from "src/common";
import { Checkbox, Icon } from "src/components";
import { WatchedDropdown } from ".";

type AllProps = {
    entry: WatchedEntryEntity;
    selected: boolean;
    path_info?: PathInfo[];
    handleAction: ActionHandlerFunction;
}

function ListRowComponent(props: AllProps) {
    const { entry, selected, handleAction } = props;
    const navigate = useNavigate();
    const [_selected, setSelected] = useState<boolean>(false);

    // Description: Handle selection changes
    useEffect(() => {
        setSelected(selected);
    }, [selected]);

    // Description: Handle the click of checkbox and changes of checkbox state 
    function handleCheckboxChange(e: FocusEvent<HTMLInputElement>) {
        const new_selected = !_selected;
        setSelected(new_selected);
        handleAction({ actionType: DriveUIActionTypes.Select, params: { selected: e.target.checked, entry } });
    }

    // Description: Build the url and navigate to MyPreVeil for now
    function handleRowClick() {
        entry.type !== DriveEntryType.FILE && navigate(buildWatchedNavigationLink(entry.collection_id, entry.id));
        return false;
    }

    return <Row
        className={`${entry.type === DriveEntryType.FILE ? "cursor-block" : ""}${!!entry.is_deleted ? " is_deleted" : ""}`}
        onClick={handleRowClick}>
        <Col md="1"> <Checkbox className="sr-only"
            onChange={(e: FocusEvent<HTMLInputElement>) => { handleCheckboxChange(e); }}
            selected={_selected ? CheckboxStates.checked : CheckboxStates.empty}
            value="all" label="Select All" disabled={false} /></Col>
        <Col md="5" className="entry-name col">
            <span data-tooltip-content={!!entry.is_deleted ? "This item was deleted from My PreVeil." : ""}
                data-tooltip-id="tb-tooltip"
                data-tooltip-place="top">
                <Icon
                    className={(!!entry.is_deleted && entry.type !== DriveEntryType.FILE) ? "ficon-folder" : (entry.type_class || getEntityIcon(entry.type))} />
                {entry.name}
            </span>
        </Col>
        <Col md="2" className="order-3">{entry.type_label}</Col>
        <Col md="3" className="order-4">{entry.last_modification_date}</Col>
        <Col md="1" className="order-md-5 order-1">
            <WatchedDropdown entry={entry} handleAction={handleAction} />
        </Col>
    </Row >;

}

export default React.memo(ListRowComponent);